import { CirclePauseIcon, FilePenLineIcon, GaugeIcon, HourglassIcon, LucideIcon, TrendingDownIcon } from 'lucide-react';
import { SeasoningReason } from '../types/withdraw';

export const reasonIcons: Record<SeasoningReason, LucideIcon> = {
  'Rate Watch': TrendingDownIcon,
  'Credit Repair': GaugeIcon,
  Forbearance: CirclePauseIcon,
  'Loan Modification': FilePenLineIcon,
  'Loan Seasoning': HourglassIcon,
};
